/* eslint-disable arrow-body-style */
/* eslint-disable @typescript-eslint/no-use-before-define */
import { RouteUrl } from '@src/common/util/routeUrl';
import { constants } from '@src/routes/provider/common/constants';
import { NavLinkProps, Permissions } from './types';

interface AllowableNavLink extends NavLinkProps {
  allowed: boolean;
}

export function getAuthorizedNavLinks(
  permissions: Permissions
): NavLinkProps[] {
  return getAllNavLinks(permissions).filter(({ allowed }) => allowed);
}

function getAllNavLinks({
  admin,
  canReadFfc,
  canSearchFfc,
  canSearchEpim,
  canSearchOptumRx,
  canSearchEvents,
  canSearchGraph,
  canRiskScore,
}: Permissions): AllowableNavLink[] {
  const size = 40;
  return [
    {
      id: 'admin',
      title: 'Administration',
      href: RouteUrl.admin,
      icon: { icon: 'code', size },
      allowed: admin,
    },
    {
      id: 'risk-score',
      title: constants.PageTitles.riskScores,
      href: RouteUrl.riskScores,
      icon: { icon: 'readiness_score', size, variant: 'outlined' },
      allowed: canRiskScore,
    },
    {
      id: 'link-analysis',
      title: 'Link Analysis',
      href: RouteUrl.linkAnalysis,
      icon: { icon: 'hub', size, variant: 'outlined' },
      allowed: canSearchGraph,
    },
    {
      id: 'event-search',
      title: 'Event Search',
      href: RouteUrl.eventsSearch,
      icon: { icon: 'data_exploration', size, variant: 'outlined' },
      allowed: canSearchEvents,
    },
    {
      id: 'global-provider-search',
      title: 'Disallowed Providers',
      href: RouteUrl.providerSearch,
      icon: { icon: 'policy_alert', size, variant: 'outlined' },
      allowed: canSearchFfc || canSearchEpim || canSearchOptumRx,
    },
    {
      id: 'manage-ffc-cases',
      title: 'Manage FFC Cases',
      href: RouteUrl.providerManage,
      icon: { icon: 'manage_search', size },
      allowed: canReadFfc,
    },
  ];
}
